import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Inactivity logout modal is shown to user',
  name: 'shown_inactivity_modal',
};

export default META;
